import ReactECharts from "echarts-for-react";

const MultiBarVertical = ({ data }) => {
  if (!Array.isArray(data) || data.length === 0) return null;

  const categories = [];
  const lysm = [];
  const lmtd = [];
  const mtd = [];
  const growthValues = [];

  let totalLYSM = 0;
  let totalLMTD = 0;
  let totalMTD = 0;

  data.forEach((item) => {
    const key = Object.keys(item)[0];
    const values = item[key];

    categories.push(key);
    lysm.push(values.LYSM);
    lmtd.push(values.LMTD);
    mtd.push(values.MTD);
    growthValues.push(values.GROWTH);

    totalLYSM += values.LYSM;
    totalLMTD += values.LMTD;
    totalMTD += values.MTD;
  });

  // Push 'Total' at the end
  categories.push("Total");
  lysm.push(totalLYSM);
  lmtd.push(totalLMTD);
  mtd.push(totalMTD);

  // Calculate and push total growth
  // const totalGrowth =
  //   totalLMTD !== 0 ? ((totalMTD - totalLMTD) / totalLMTD) * 100 : 0;
  // growthValues.push(totalGrowth);

  const totalGrowth =
    totalLMTD !== 0 ? ((totalMTD - totalLMTD) / totalLMTD) * 100 : totalMTD;
  growthValues.push(totalGrowth);

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    legend: {
      bottom: 0,
    },
    grid: {
      top: "10%",
      left: "3%",
      right: "4%",
      bottom: "15%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: categories,
      axisTick: { alignWithLabel: true },
    },
    yAxis: {
      type: "value",
      splitLine: { show: false },
    },
    color: ["#A189F5", "#FAD6B2", "#64DAF6"],
    series: [
      {
        name: "LYSM",
        type: "bar",
        data: lysm,
        barWidth: "30%",
        barGap: 0,
        barCategoryGap: "40%",
        label: {
          show: true,
          position: "top",
          fontSize: 9,
        },
      },
      {
        name: "LMTD",
        type: "bar",
        data: lmtd,
        barWidth: "30%",
        label: {
          show: true,
          position: "top",
          fontSize: 9,
        },
      },
      {
        name: "MTD",
        type: "bar",
        data: mtd,
        barWidth: "30%",
        label: {
          show: true,
          position: "top",
          formatter: function (params) {
            return `${params.value}`;
          },
          fontSize: 9,

          align: "center",
        },
        markPoint: {
          symbol: "circle", // We use a small invisible symbol to trigger label position
          symbolSize: [1, 1], // invisible point
          label: {
            show: true,
          },
          data: mtd.map((value, index) => {
            const growth = growthValues[index];
            const isPositive = growth > 0;
            const triangle = isPositive ? "▲" : "▼";
            const color = isPositive ? "#28a745" : "#dc3545";

            return {
              coord: [index, value],
              label: {
                show: true,
                formatter: `{value|${triangle} ${Math.abs(growth).toFixed(
                  1
                )}%}`,
                position: "top",
                offset: [5, -20],
                rich: {
                  value: {
                    color: color,
                    fontSize: 12,
                    fontWeight: "bold",
                    align: "center",
                    verticalAlign: "middle",
                  },
                },
              },
              symbolSize: 1,
              itemStyle: {
                color: color,
              },
            };
          }),
        },
      },
    ],
  };

  return <ReactECharts option={option} style={{ height: 248 }} />;
};

export default MultiBarVertical;
